"use client"

import React from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import {
  AvatarWithNameAndTitleContent,
  AvatarWithNameAndTitleSize,
  AvatarWithNameAndTitleSizeVariant,
} from "./AvatarWithNameTitleContent"
import { useRouter } from "next-nprogress-bar"
import clsx from "clsx"

const CreativeAvatarWithNameAndTitleFragment = graphql(`
  fragment CreativeAvatarWithNameAndTitle on IndividualCreative {
    id
    professionString
    displayName
    handle
    user {
      id
      name
      ...AvatarWithNameAndTitleContent
    }
  }
`)

interface Props {
  creative: FragmentType<typeof CreativeAvatarWithNameAndTitleFragment> | null | undefined
  size: AvatarWithNameAndTitleSize
  variant: AvatarWithNameAndTitleSizeVariant
  className?: string
  canClick?: boolean
  titleMaxLines?: number
  subtitleMaxLines?: number
  redacted?: boolean
}

/*
 * This component should be used if you're only ever going to display a creatives name and title.
 * use the User version if it's possible that the user could be a creative
 */
export const CreativeAvatarWithNameAndTitle: React.FC<Props> = props => {
  const creative = useFragment(CreativeAvatarWithNameAndTitleFragment, props.creative)
  const router = useRouter()
  const { className, size, variant, canClick = true } = props
  const user = creative?.user
  const title = creative?.displayName || user?.name

  const subtitle = creative?.professionString

  return (
    <div
      className={clsx(canClick && "cursor-pointer")}
      onClick={e => {
        if (canClick) {
          e.preventDefault()
          e.stopPropagation()
          router.push(`/${creative?.handle}`)
        }
      }}>
      <AvatarWithNameAndTitleContent
        title={title}
        subtitle={subtitle}
        className={className}
        variant={variant}
        size={size}
        user={user}
        subtitleMaxLines={props.subtitleMaxLines}
        titleMaxLines={props.titleMaxLines}
        redacted={props.redacted}
      />
    </div>
  )
}
